import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SemnatariComponent } from './semnatari.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [SemnatariComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [SemnatariComponent]
})
export class SemnatariModule { }
